import { render, staticRenderFns } from "./restoreBox.vue?vue&type=template&id=6782d630&"
import script from "./restoreBox.vue?vue&type=script&lang=js&"
export * from "./restoreBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports